export function processNotificationSocketMessage(data, handlers) {
    const count = Number(data.unreadChats ?? 0);
    if (Number.isFinite(count)) {
        handlers.onUnreadCount?.(count);
    }
    // Pending tour feedback comes straight off the socket, same as the unread
    // count. Backend sends the current pending list and drops items once they're
    // submitted, so we just store it as-is.
    if (Array.isArray(data.feedbackPrompt)) {
        handlers.onTourFeedbackPrompts?.(data.feedbackPrompt);
    }
}
